import { render, staticRenderFns } from "./ThemeCard.vue?vue&type=template&id=32545150&scoped=true"
import script from "./ThemeCard.vue?vue&type=script&lang=js"
export * from "./ThemeCard.vue?vue&type=script&lang=js"
import style0 from "./ThemeCard.vue?vue&type=style&index=0&id=32545150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32545150",
  null
  
)

export default component.exports